import { UserInput } from 'admin/inputs/UserInput';
import { List, SelectInput } from 'react-admin';

import { UserRelationDatagrid } from './UserRelationDatagrid';
import { USER_RELATION_TYPES } from './userRelationUtils';

export const UserRelationList: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filters = [
    <UserInput label="Kto" source="subjectUser.id" />,
    <SelectInput choices={USER_RELATION_TYPES} label="Má vzťah" source="relationType" />,
    <UserInput label="Ku komu" source="objectUser.id" />,
  ];

  return (
    <List debounce={1000} exporter={false} filters={filters} sort={{ field: 'creationTimestamp', order: 'DESC' }}>
      <UserRelationDatagrid />
    </List>
  );
};
